import { Component, ChangeDetectorRef, ViewChild, ElementRef, OnInit, Input } from '@angular/core';
import { InfoService } from '../../service/info.service';
import { UserService } from '../../service/user.service';
import { User } from 'src/app/model/user';
import { ImageCroppedEvent, base64ToFile } from 'ngx-image-cropper';

@Component({
  selector: 'app-change-profile-picture',
  templateUrl: './change-profile-picture.component.html',
  styleUrls: ['./change-profile-picture.component.scss']
})
export class ChangeProfilePictureComponent implements OnInit {
  @ViewChild('imageInput', { static: true }) imagePicture: ElementRef;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImageAvatar: any = '';
  cropSection: boolean = false;
  // Recebe o user do consumidor (ex.: landing-profile). Quando ausente,
  // fallback pra um fetch próprio via getUserFromToken — preserva uso
  // standalone do componente.
  @Input() user: User;
  // `imageAvatarUrl`/`imageUrl` podem apontar pra uma foto que existe no
  // banco mas falha ao carregar (404, arquivo removido, etc.) — sem isso o
  // <img> ficava com o ícone de imagem quebrada em vez de cair pro
  // ngx-avatar. Não afeta o preview local (`croppedImage`), que não falha.
  imageError = false;

  constructor(
    private ref: ChangeDetectorRef,
    public infoService: InfoService,
    public userService: UserService
  ) { }

  ngOnInit(): void {
    if (!this.user) {
      this.userService.getUserFromToken().subscribe(user => {
        this.user = user;
        this.imageError = false;
      });
    }
  }

  processPicture(event: any): void {
    this.imageChangedEvent = event;
    this.cropSection = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.imageError = false;
    this.resizeProfileImageAvatar();
  }

  showProfileImage(): string {
    if (this.croppedImage) { return this.croppedImage; }
    // Mesmo fallback do navbar: avatarUrl quando disponível, senão imageUrl.
    return this.user?.profile?.imageAvatarUrl || this.user?.profile?.imageUrl;
  }

  resizeProfileImageAvatar () {
    const img = new Image();
    img.src = this.croppedImage;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 300;
      canvas.height = 300;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      this.croppedImageAvatar = canvas.toDataURL('image/png');
    };
  }

  resetCrop() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.croppedImageAvatar = '';
    this.cropSection = false;

    (<HTMLInputElement>document.getElementById('imageInput')).value = '';
  }

  cancelCrop() {
    this.resetCrop();
  }

  saveCrop() {
    let imageBlob = base64ToFile(this.croppedImage);
    let imageAvatarBlob = base64ToFile(this.croppedImageAvatar);
    let imageFile = new File([imageBlob], this.imageChangedEvent.target.files[0].name);
    let imageAvatarFile = new File([imageAvatarBlob], this.imageChangedEvent.target.files[0].name);

    this.userService.changePicture(this.user, imageFile, imageAvatarFile).subscribe(profile => {
      setTimeout(() => {
        const user = this.user;
        user.profile = profile;
        this.user = user;
        this.imageError = false;

        this.ref.detectChanges();
      });
    });

    this.resetCrop();
  }

  removePicture(): void {
    this.userService.removePicture(this.user.id).subscribe(res => {
      const user = this.user;
      user.profile = res.data;
      this.user = user;
      this.imageError = false;
      this.ref.detectChanges();
    });
  }
}
